import { render, staticRenderFns } from "./ContactChip.vue?vue&type=template&id=89bcd1a4&"
import script from "./ContactChip.vue?vue&type=script&lang=js&"
export * from "./ContactChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports